import React from 'react'
import SingleFileUploader from '../Constants/SingleFileUploader'
import "./LegalAnalyzer.css";

function LegalAnalyzer() {
  return (
<div className="legal-research-container">
      <h1 style={{marginBottom:"36px"}}>To analyse your document, drop your file here:</h1>
      <SingleFileUploader />
    </div>
  )
}

export default LegalAnalyzer